module.exports = __webpack_public_path__ + "img/plata.ea2cf9cb.png";